import { computed } from "vue";

export function useHyperpay(cardType) {
  const dataBrands = computed(() => {
    if (cardType === "save_card") {
      return "";
    }
    return cardType === "credit_card" ? "VISA MASTER MADA" : "APPLEPAY";
  });

  return {
    dataBrands,
  };
}
